import { Button, COLOR } from '@cosuno/cosuno-ui';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { zIndexValues } from '~/shared/utils/styles';

export const InvisibleDiv = styled.div`
  display: none;
`;

const flexStyles = css`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 15px;
`;

export const Bar = styled(Link)`
  ${flexStyles}
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  background-color: ${COLOR.highlightNeon};
  padding: 15px;
  z-index: ${zIndexValues.subcontractorProfilePromptBar};
`;

export const TextWrapper = styled.div`
  ${flexStyles}
`;

export const PromptButton = styled(Button)`
  background-color: ${COLOR.white};
  color: ${COLOR.brand};
  border-width: 0;

  &:hover,
  &:focus {
    background-color: ${COLOR.white};
    border-width: 0;
  }
`;
